module.exports = __webpack_public_path__ + "static/media/guide.2af27928.png";